import './salusuniversity/style';
import FormStructure from './salusuniversity/form_structure';

export default FormStructure;